export const toastDefaults = {
  position: "top-right",
  duration: 3000,
  isClosable: true,
};
